import React from 'react';

const NotFound = () => {
    return (
        <div>

            <img src="https://freefrontend.com/assets/img/html-funny-404-pages/CodePen-404-Page.gif" alt="" srcset="" />
        </div>
    );
};

export default NotFound;